/**
 * Interface for ElasticForm, ElasticScreen and ElasticQuestion.
 * Because JavaScripts has no support for Interfaces
 * this is actually a class which should be extended by Elastic classes
 */
class ElasticInterface {
    serialize () { /* stub */ }
    destructor () { throw new Error('Destructor is not implemented'); }
    validate () { return true; }

    /**
     * Clone object key->values pairs from external to current object.
     * @param obj
     */
    assignObjKeys (obj) {
        Object.keys(obj).forEach((key) => this[key] = obj[key]);
    }
}
